import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/697901df921dc90014aa0b7a/shoparroobiz/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697901df921dc90014aa0b7a/shoparroobiz/src/app/contact-strategy-discussion/components/ContactInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697901df921dc90014aa0b7a/shoparroobiz/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/697901df921dc90014aa0b7a/shoparroobiz/src/components/ui/AppIcon.tsx");
